import SubscriptionsAndNotificationsSection from './SubscriptionsAndNotificationsSection';

export default SubscriptionsAndNotificationsSection;
